/** Minimum/maximum energy value (kWh/(a·m²)) shown on the energy efficiency scale. */
export const ENERGY_SCALE_MIN = 0;
export const ENERGY_SCALE_MAX = 260;

export interface EnergyScaleInterval {
    label: string;
    start: number;
    end: number;
}

/** Energy efficiency class intervals (A+ to H) shown on the scale. */
export const ENERGY_SCALE_INTERVALS: EnergyScaleInterval[] = [
    {label: "A+", start: 0, end: 30},
    {label: "A", start: 30, end: 50},
    {label: "B", start: 50, end: 75},
    {label: "C", start: 75, end: 100},
    {label: "D", start: 100, end: 130},
    {label: "E", start: 130, end: 160},
    {label: "F", start: 160, end: 200},
    {label: "G", start: 200, end: 250},
    {label: "H", start: 250, end: 260},
];

/** Vertical separators drawn between energy efficiency classes. */
export const ENERGY_SCALE_BOUNDARIES = [30, 50, 75, 100, 130, 160, 200, 250];

/** Horizontal position (0-100, in %) of a value on the energy scale, clamped to [min, max]. */
export function getEnergyScalePositionPercent(value: number): number {
    const clamped = Math.max(ENERGY_SCALE_MIN, Math.min(value, ENERGY_SCALE_MAX));
    return ((clamped - ENERGY_SCALE_MIN) / (ENERGY_SCALE_MAX - ENERGY_SCALE_MIN)) * 100;
}

/** Whether an energy_type value represents "Bedarf" (demand) as opposed to "Verbrauch" (consumption). */
export function isEnergyDemand(energyType: number | null | undefined): boolean {
    return energyType === 1;
}
